import { JSX, useEffect } from 'react';
import { legalContent } from '../data/legalContent';
import { useNavigate } from 'react-router-dom';
import useAppStore from '../stores/useAppStore';

export default function TermsOfServicePage(): JSX.Element {
  const { terms } = legalContent;
  const navigate = useNavigate();
  const { navigationHistory } = useAppStore();

  useEffect(() => {
    // Set page title
    document.title = `${terms.title} - Fabrik 28`;
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', `${terms.title} for Fabrik 28 AI platform`);
    }
    
    // Scroll to top
    window.scrollTo(0, 0);
  }, [terms.title]);

  const handleBackToHome = (): void => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* Header with context-aware navigation - Hide when coming from registration modal */}
      {!navigationHistory.shouldShowBackButton && (
        <header className="bg-white dark:bg-gray-800 shadow-sm">
          <div className="container-max section-padding">
            <div className="flex items-center justify-between py-3">
              <button
                className="text-sm text-primary-600 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300 transition-colors"
              >
              </button>
              <button
                onClick={handleBackToHome}
                className="text-sm text-primary-600 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300 transition-colors"
              >
                Home
              </button>
            </div>
          </div>
        </header>
      )}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg dark:prose-invert max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
            {terms.title}
          </h1>
          
          <div className="text-gray-600 dark:text-gray-300 space-y-6">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Last updated: {terms.lastUpdated}
            </p>
            
            {/* Converted markdown content */}
            <div 
              className="legal-content space-y-6"
              dangerouslySetInnerHTML={{ __html: terms.content }}
            />
            
            <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                If you have any questions about these Terms and Conditions, please contact us at{' '}
                <a 
                  href="mailto:legal@fabrik28.ai" 
                  className="text-blue-600 dark:text-blue-400 hover:underline"
                >
                  legal@fabrik28.ai
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
